var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.style.viewPush }, [
    _c("div", { staticClass: "asc__errorpage" }, [
      _c("h3", [
        _vm._v(_vm._s(_vm.info ? _vm.info : _vm.$t("general.serverError")))
      ]),
      _vm._v(" "),
      _c("img", { attrs: { src: require("../../static/error.png") } }),
      _vm._v(" "),
      _c(
        "footer",
        [
          _c("a", { attrs: { href: "mailto:support@ideateknoloji.com.tr" } }, [
            _vm._v(_vm._s(_vm.$t("general.supportMail")))
          ]),
          _vm._v(" | "),
          _c("router-link", { attrs: { to: { name: "Dashboard" } } }, [
            _vm._v(_vm._s(_vm.$t("general.homepage")))
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-026a7a08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-026a7a08","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = null
// module chunks = 